import AppConstants from '../../../config/app.constants';

class CurrencyPickReportController {
  /*@ngInject*/
  constructor($state, $stateParams, OrderPackingService, Modal, $translate, $rootScope, User, SetupService, BranchFundingSourceService, $q, RouteService, DateUtil, BranchService, DataCounter) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.OrderPackingService = OrderPackingService;
    this.Modal = Modal;
    this.$translate = $translate;
    this.$rootScope = $rootScope;
    this.User = User;
    this.SetupService = SetupService;
    this.BranchFundingSourceService = BranchFundingSourceService;
    this.$q = $q;
    this.RouteService = RouteService;
    this.DateUtil = DateUtil;
    this.BranchService = BranchService;
    this.DataCounter = DataCounter;

    this.$rootScope.$broadcast('routeChange', '/app/currency-pick-report');

    this.model = {
      date: new Date(),
      fundingSource: null,
      route: null,
      loading: false,
    };
    this.isCoinCheckOut = false;

    this.locationLists = [];
    this.routeList = [];
  }

  $onInit() {
    this.title = 'Currency Pick Report';
    this.branchId = this.User.getUser().branchId;
    this.customerId = this.User.getUser().customerUser ? this.User.getUser().customerId : null;
    this.SetupService.get(this.branchId)
      .then((data) => {
        this.model.date = this.DateUtil.convertToDate(data.currentVaultDate || undefined);
        
        const dataObj = this.DataCounter.getData();
        if (dataObj && dataObj.date) {
            this.model.date = moment(dataObj.date).toDate();
        }

        this.isCoinCheckOut = data.coinCheckOut;
      })
      .catch((err) => {
        this.error = err.message
      }).finally(() => {
        this.getFundingSource('', 0).then(() => {
            const dataObj = this.DataCounter.getData();
            if (dataObj && dataObj.fundingSourceId) {
                this.model.fundingSource = this.locationLists.find(item => String(item.Id) === String(dataObj.fundingSourceId));
                if (this.model.fundingSource) {
                    this.loadData();
                    this.loadRoutes();
                }
            }
        });
        this.loadRoutes();
      })

  }

  loadRoutes() {
    const vaultDate = moment(this.model.date).format('YYYY-MM-DD');
    // this.RouteService.getBranchRoutes(this.branchId, vaultDate)
    this.BranchService.getReleaseRoutes(this.branchId, vaultDate, this.isCoinCheckOut)
      .then((data) => {
        this.routeList = data || [];
      })
      .catch((err) => {
        console.log(err);
      });
  }

  locationSearchObj(searchKey) {
    searchKey = searchKey || '';
    return {
      queryJSON: {
        rules: [
          { field: 'branchId', condition: '=', data: this.branchId },
          // { field: 'enforceStraps', condition: '=', data: true },
          {
            group: {
              rules: [
                { field: 'locationId', condition: 'like', data: '%' + searchKey + '%' },
                { field: 'sourceName', condition: 'like', data: '%' + searchKey + '%' }
              ],
              operator: 'OR'
            }
          }
        ],
        operator: 'AND'
      }
    };
  }

  getFundingSource(searchKey, offset) {
    const loadLocationData = this.locationSearchObj(searchKey);
    return this.BranchFundingSourceService.all(loadLocationData, offset, AppConstants.defaultPageLimit, this.customerId)
      .then((data) => {
        const mapped = data.results.map((fs) => ({
          Key: fs.locationId + " | " + fs.sourceName,
          Value: fs.locationId,
          Id: fs.id
        }));

        if (offset === 0) {
          this.totalRecords = data.total;
          this.locationLists = mapped;
        } else {
          this.locationLists = this.locationLists.concat(mapped);
        }
        return data;
      });
  }

  loadData() {
    if (!this.model.fundingSource || !this.model.date) return;
    this.model.loading = true;
    this.OrderPackingService.orderPackingList(this.branchId, this.model.fundingSource.Value)
      .then((data) => {
        this.allShipments = data || [];
        this.filterData();
      })
      .catch(err => console.error('Error loading report:', err))
      .finally(() => {
        this.model.loading = false;
      });
  }

  filterData() {
    const selectedRouteId = this.model.route;
    const selectedDate = moment(this.model.date).format('YYYY-MM-DD');
    const shipments = (this.allShipments || []).filter(item => {
      const routeMatch = !selectedRouteId || selectedRouteId === 'ALL' || item.routeId === selectedRouteId;
      const dateMatch = !selectedDate || (item.vaultDate && moment.utc(item.vaultDate).format('YYYY-MM-DD') === selectedDate);
      const coinFlag = !item.denomination.coinFlag;
      return routeMatch && dateMatch && coinFlag;
    });
    const denomsMap = {};
    shipments.forEach(item => {
      const d = item.denomination;
      if (!d) return;
      if (!denomsMap[d.id]) {
        denomsMap[d.id] = {
          id: d.id,
          name: d.name,
          faceValue: Number(d.faceValue),
          strapCount: Number(d.strapCount) || 100,
          bundleCount: Number(d.bundleCount) || 10,
          bundleQty: 0,
          bundleAmt: 0,
          strapQty: 0,
          strapAmt: 0,
          looseQty: 0,
          looseAmt: 0,
          total: 0
        };
      }
      denomsMap[d.id].total += Number(item.amount);
    });

    Object.values(denomsMap).forEach(target => {
      const totalBills = Math.floor(target.total / target.faceValue);
      const billsPerStrap = target.strapCount;
      const strapsPerBundle = target.bundleCount;
      const billsPerBundle = billsPerStrap * strapsPerBundle; // 1000

      const bundleQty = Math.floor(totalBills / billsPerBundle);
      target.bundleQty = bundleQty;
      target.bundleAmt = bundleQty * billsPerBundle * target.faceValue;

      let remainingBills = totalBills - (bundleQty * billsPerBundle);

      const strapQty = Math.floor(remainingBills / billsPerStrap);
      target.strapQty = strapQty;
      target.strapAmt = strapQty * billsPerStrap * target.faceValue;

      remainingBills -= strapQty * billsPerStrap;

      target.looseQty = remainingBills;
      target.looseAmt = remainingBills * target.faceValue;
    });

    this.denominations = Object.values(denomsMap).sort((a, b) => a.faceValue - b.faceValue);

    this.grandTotals = {
      bundleAmt: 0,
      strapAmt: 0,
      looseAmt: 0,
      total: 0
    };
    this.denominations.forEach(d => {
      this.grandTotals.bundleAmt += d.bundleAmt;
      this.grandTotals.strapAmt += d.strapAmt;
      this.grandTotals.looseAmt += d.looseAmt;
      this.grandTotals.total += d.total;
    });
  }

  formatAmount(amount) {
    return amount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: amount < 1 ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  print() {
    const printData = {
      date: moment(this.model.date).format('MM/DD/YYYY'),
      routeId: this.model.route ? this.model.route : null,
      fundingSource: this.model.fundingSource ? this.model.fundingSource.Key : '',
      denominations: this.denominations,
      grandTotals: this.grandTotals
    };
    const path = this.$state.href('printCurrencyPickReport');
    window.w = window.open(path, '_blank');
    window.w.printData = printData;
  }
}

export default CurrencyPickReportController;



// WEBPACK FOOTER //
// ./client/app/components/order_packing/currency_pick_report/currency_pick_report.controller.js